export interface CarbonScore {
  calculationMethodology: string;
  externalCategory: CarbonScoreExternalCategory;
  product: CarbonScoreProduct;
}

export enum CarbonScoreEquivalence {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
}

export interface CarbonScoreExternalCategory {
  averageCarbonFootprint: number;
  averageCarbonScore: CarbonScoreEquivalence;
  averagePosition: number;
  maxCarbonFootprint: number;
  minCarbonFootprint: number;
  totalProductsCount: number;
}

export interface CarbonScoreProduct {
  carbonFootprint: number;
  carbonScore: CarbonScoreEquivalence;
  confidenceIndicator: number;
  lifecycleAssessment: CarbonScoreLifecycleAssessment;
  positionInCategory: number;
}

export interface CarbonScoreLifecycleAssessment {
  endOfLifeCarbonFootprint: number;
  manufacturingCarbonFootprint: number;
  materialExtractionCarbonFootprint: number;
  transportationCarbonFootprint: number;
  usageCarbonFootprint: number;
}
